module.exports = __webpack_public_path__ + "static/media/print-slash.9d780fcf.svg";